<div class="content-padding">
  @if (options?.projectId) {
    <div class="content-header-fixed">
      <div class="return-link-wrapper">
        <a
          *transloco="let t; read: 'documents.view'"
          class="link"
          [routerLink]="['/groups', groupId, 'projects', projectId, 'dashboards', dashboardId]"
          [state]="{ skipPinningInit: true }"
          >&lt;&lt; {{ t('back-to-dashboard') }}
        </a>
      </div>
    </div>
    <app-document-view [options]="options" (highlightChange)="onHighlightChange($event)">
    </app-document-view>
  }
</div>
